<template>
  <fragment>
    <hero-header :page-name="$store.state.DeviceManagement.deviceDisplayName" hero-title="personalInformations"/>
    <personal-details-form></personal-details-form>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import PersonalDetailsForm from '../components/PersonalDetailsForm.vue';

export default {
  name: 'CustomerPage',
  components: {
    heroHeader, PersonalDetailsForm,
  },
  props: {
    //
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
};
</script>

<style scoped>

</style>
